import { FC, useContext } from "react";
import Link from "next/link";
import { useSelector } from "react-redux";
import { Text, Heading } from "@otrium/atoms";
import { Box, Flex } from "@otrium/core";
import { Trans } from "@lingui/macro";
import { Money } from "src/types/ctgraphql.d";
import { AppCtx } from "src/contexts/app.context";
import { getGenderId } from "src/modules/page";
import { Notification } from "src/icons";
import { CloseButton } from "src/atoms/CloseButton";
import { CTPrice } from "src/atoms/CTPrice";
import { Modal } from "src/atoms/Modal";
import { getI18nRoute } from "src/utils/i18nRoutes";
import { StyledSmallButton } from "src/organisms/CartView/CartView.styled";

const CartNotificationModal: FC<{ isOpen: boolean; onClose: () => void }> = ({
  isOpen,
  onClose,
}) => {
  const {
    locale,
    cartMinLineItemsTotalPriceDiff,
    cartMinLineItemsTotalPriceCentAmount,
  } = useContext(AppCtx);
  const genderId = useSelector(getGenderId);

  const cartMinLineItemsTotalPrice = {
    ...cartMinLineItemsTotalPriceDiff,
    centAmount: cartMinLineItemsTotalPriceCentAmount,
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      fullHeight={false}
      centerOnScreen={true}
    >
      <Box p={3} sx={{ width: "328px" }}>
        <Box sx={{ position: "relative" }}>
          <CloseButton
            fill="#000"
            onClick={onClose}
            sx={{ position: "absolute", right: "-8px", top: "-4px" }}
          />
          <Flex>
            <Notification width="26px" height="26px" />
            <Heading
              as="h4"
              variant="h4"
              mt="2px"
              ml={2}
              pb={0}
              fontFamily="PlusJakartaSans"
            >
              <Trans id="cart_notification_modal.header_warning">Oops</Trans>
            </Heading>
          </Flex>
        </Box>
        <Text mt={2} mb={3} variant="body.source.regular16" letterSpacing={0}>
          <Trans id="cart_notification_modal.min_cart_subtotal_warning">
            You&apos;re{" "}
            <CTPrice price={cartMinLineItemsTotalPriceDiff as Money} /> away
            from reaching our minimum order value of{" "}
            <CTPrice price={cartMinLineItemsTotalPrice as Money} />. Please add
            more items to complete your order
          </Trans>
        </Text>
        <Link
          href={`${getI18nRoute({
            route: `/${genderId as string}`,
            locale,
          })}/categories`}
          passHref
          legacyBehavior
        >
          <StyledSmallButton as="a" variant="primary" fullWidth>
            <Trans>Continue shopping</Trans>
          </StyledSmallButton>
        </Link>
      </Box>
    </Modal>
  );
};

export { CartNotificationModal };
